import '@ungap/global-this';
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import Vuex from 'vuex';
import "@/conf/common.conf.js";
import realtimeStore from "@/store/realtime.store.js";
import covid19Store from "@/store/covid19.store.js";
import App from '@/views/realtime/RealtimeApp.vue';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        realtimeStore,
        covid19Store,
    }
});

new Vue({
    render: h => h(App),
    store,
}).$mount('#app');
